(() => {
  const numberOf = value => { const match = String(value).replace(',', '.').match(/[+-]?\d+(?:\.\d+)?/); return match ? Number(match[0]) : NaN; };
  function enhance(select, page) {
    if (select.dataset.plRxEnhanced) return;
    select.dataset.plRxEnhanced = 'true';
    const entries = [...select.options].slice(1).map(option => ({ value: option.value, label: option.textContent, number: numberOf(option.value), disabled: option.disabled }));
    const zero = entries.find(item => item.number === 0 || /(?:plano|0[.,]00)/i.test(item.label));
    const negative = entries.filter(item => item.value.trim().startsWith('-') || item.number < 0).sort((a, b) => Math.abs(a.number) - Math.abs(b.number));
    const positive = entries.filter(item => item.value.trim().startsWith('+') || item.number > 0).sort((a, b) => a.number - b.number);
    const wrap = document.createElement('div'); wrap.className = 'pl-rx-select';
    const button = document.createElement('button'); button.type = 'button'; button.className = 'pl-rx-select__button'; button.textContent = select.options[0]?.textContent || 'Select'; button.setAttribute('aria-expanded', 'false');
    const menu = document.createElement('div'); menu.className = 'pl-rx-select__menu'; menu.hidden = true;
    const positionMenu = () => {
      if (menu.hidden) return;
      menu.style.left = '50%';
      menu.style.right = 'auto';
      menu.style.transform = 'translateX(-50%)';
      menu.style.marginLeft = '0px';
      const bounds = menu.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;
      const offset = bounds.left < 16 ? 16 - bounds.left : Math.min(0, viewportWidth - 16 - bounds.right);
      menu.style.marginLeft = `${offset}px`;
    };
    const close = () => {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
    };
    const makeOption = (item, className = '') => { const el = document.createElement('button'); el.type = 'button'; el.className = className; el.textContent = item.label; el.disabled = item.disabled; if (item.disabled) { el.setAttribute('aria-disabled', 'true'); el.title = page.dataset.rxUnavailable || ''; } el.addEventListener('click', () => { if (item.disabled) return; select.value = item.value; button.textContent = item.number === 0 ? page.dataset.rxZero : item.label; close(); select.dispatchEvent(new Event('change', { bubbles: true })); }); return el; };
    if (zero) {
      const zeroOption = makeOption(zero, 'pl-rx-select__zero');
      zeroOption.textContent = page.dataset.rxZero || 'Non-Prescription (0.00)';
      menu.append(zeroOption);
    }
    const hasNegative = negative.length > 0;
    const hasPositive = positive.length > 0;
    const heads = document.createElement('div'); heads.className = `pl-rx-select__heads${hasNegative !== hasPositive ? ' is-single' : ''}`;
    if (hasNegative) { const head = document.createElement('strong'); head.className = 'pl-rx-select__head--negative'; head.textContent = page.dataset.rxMyopia; heads.append(head); }
    if (hasPositive) { const head = document.createElement('strong'); head.className = 'pl-rx-select__head--positive'; head.textContent = page.dataset.rxHyperopia; heads.append(head); }
    if (hasNegative || hasPositive) menu.append(heads);
    const rows = document.createElement('div'); rows.className = `pl-rx-select__rows${hasNegative !== hasPositive ? ' is-single' : ''}`;
    for (let i = 0; i < Math.max(negative.length, positive.length); i++) {
      if (hasNegative) rows.append(negative[i] ? makeOption(negative[i], 'pl-rx-select__option--negative') : Object.assign(document.createElement('span'), { ariaHidden: 'true' }));
      if (hasPositive) rows.append(positive[i] ? makeOption(positive[i], 'pl-rx-select__option--positive') : Object.assign(document.createElement('span'), { ariaHidden: 'true' }));
    }
    const scroll = document.createElement('div'); scroll.className = 'pl-rx-select__scroll'; scroll.append(rows); menu.append(scroll);
    select.parentNode.insertBefore(wrap, select); wrap.append(select, button, menu); select.classList.add('pl-rx-native-select'); select.tabIndex = -1;
    menu.addEventListener('pointerdown', event => event.stopPropagation());
    menu.addEventListener('click', event => event.stopPropagation());
    button.addEventListener('click', event => {
      event.stopPropagation();
      const opening = menu.hidden;
      document.querySelectorAll('.pl-rx-select.is-open').forEach(node => {
        if (node !== wrap) node.querySelector('.pl-rx-select__button')?.click();
      });
      menu.hidden = !opening;
      button.setAttribute('aria-expanded', String(opening));
      wrap.classList.toggle('is-open', opening);
      if (opening) positionMenu();
    });
    wrap.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !menu.hidden) {
        event.preventDefault();
        close();
        button.focus();
      }
    });
    window.addEventListener('resize', positionMenu);
    document.addEventListener('click', event => { if (!wrap.contains(event.target)) close(); });
  }
  function init(scope = document) { scope.querySelectorAll('.pl-product-page').forEach(page => page.querySelectorAll('[data-pl-prescription-power]').forEach(select => enhance(select, page))); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
